import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c64c686"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "AML Verification Overview", -1))
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_9 = { class: "d-flex flex-stack mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Status", -1))
const _hoisted_11 = { class: "d-flex align-items-center me-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-6" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SummaryCard = _resolveComponent("SummaryCard")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$modals.VIEW_AML_VERIFICATION_MODAL,
    ref: "viewAMLVerificationModalRef",
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    backdrop: "static",
    keyboard: "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            id: `${_ctx.$modals.VIEW_AML_VERIFICATION_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge badge-lg", {
                    'badge-danger':
                      _ctx.verification?.status === _ctx.AMLVerificationStatus.FOUND,
                    'badge-success':
                      _ctx.verification?.status === _ctx.AMLVerificationStatus.NOT_FOUND,
                    'badge-info':
                      _ctx.verification?.status === _ctx.AMLVerificationStatus.PENDING,
                  }])
                    }, _toDisplayString(_ctx.verification?.status_display), 3)
                  ])
                ]),
                _hoisted_12,
                (_ctx.verification?.status === _ctx.AMLVerificationStatus.FOUND)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_SummaryCard, {
                        title: "Title",
                        "right-text": _ctx.matched?.title,
                        subtitle: "Title as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-primary-info",
                        color: "primary"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "First Name",
                        "right-text": _ctx.matched?.first_name,
                        subtitle: "First name as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-light-primary",
                        color: "primary"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Last Name",
                        "right-text": _ctx.matched?.last_name,
                        subtitle: "Last name as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-light-info",
                        color: "info"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Address",
                        "right-text": _ctx.matched?.address,
                        subtitle: "Address as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-warning-info",
                        color: "warning"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Country",
                        "right-text": _ctx.matched?.country,
                        subtitle: "Country as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-danger-info",
                        color: "danger"
                      }, null, 8, ["right-text"]),
                      _createVNode(_component_SummaryCard, {
                        title: "Date of birth",
                        "right-text": _ctx.matched?.date_of_birth || '-',
                        subtitle: "Date of birth as matched from AML records",
                        icon: "/media/icons/duotune/electronics/elc001.svg",
                        variant: "bg-info-info",
                        color: "info"
                      }, null, 8, ["right-text"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, "AML records not found")),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger w-100 mt-4",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, " Close ")
              ], 64))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}